import { FC, useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CustomFormField, SpeciesForm } from '../../../../../api/dtos/dtos';
import { useField, useFormState } from '@ngt/forms-core';

interface ICustomRichTextEditorProps {
    field: CustomFormField;
    form: SpeciesForm;
}

const CustomRichTextEditor: FC<ICustomRichTextEditorProps> = ({form, field}) => {

    // 
    // Form Values
    const { value } = useFormState({ value: true });

    //
    // -- Form Field --
    const targetField = useField(`${form?.name}.${field?.meta?.targetName}`);

    //
    // -- States --
    const [input, setInput] = useState<string>('');

    const handleChange = (content: string, _delta: any, _source: string, editor: any) => {
        setInput(content);
        targetField.setValue(editor.getHTML());
    };

    // Initalise field
    useEffect(() => {
        if (value && value[form?.name] && field){
            setInput(value[form?.name]?.[(field as any)?.meta?.targetName]);
        }
    }, [value, form, field]);

    return (
        <ReactQuill 
            theme="snow" 
            value={input} 
            onChange={handleChange} 
            modules={{
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],        // toggled buttons
                    ['link'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                    [{ 'align': [] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    // [{ 'font': [] }],
                    // ['clean'] 
                ],
            }}
        />
    );
};

export default CustomRichTextEditor;